<template>
  <el-table-column
    prop="short_name"
    sortable
    label="Rövid név"
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      {{ scope.row.short_name }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'short_name',
  };
</script>
